module.exports = __webpack_public_path__ + "img/from_toeicBTest_content01.7c19d708.svg";